var map = {
	"./icons-10/stars_empty.svg": "fb65",
	"./icons-10/stars_full.svg": "0dab",
	"./icons-120/empty_state_payments.svg": "04dd",
	"./icons-16/download.svg": "4226",
	"./icons-16/error.svg": "f1a3",
	"./icons-16/failed.svg": "472c",
	"./icons-16/success.svg": "3c91",
	"./icons-16/warning.svg": "f3c6",
	"./icons-16/xperts.svg": "1545",
	"./icons-24/add-client.svg": "c412",
	"./icons-24/apple.svg": "b14b",
	"./icons-24/appointment.svg": "ffc4",
	"./icons-24/credit-card.svg": "e8d1",
	"./icons-24/document.svg": "98c7c",
	"./icons-24/estimate.svg": "944a",
	"./icons-24/event.svg": "a4e9",
	"./icons-24/exclamation-circle.svg": "5ba6",
	"./icons-24/exclamation-triangle.svg": "6540",
	"./icons-24/google.svg": "a68d",
	"./icons-24/instagram.svg": "2469",
	"./icons-24/internal_document.svg": "944a3",
	"./icons-24/invite-to-portal.svg": "f021",
	"./icons-24/invite-to-schedule.svg": "a669",
	"./icons-24/invite-via-email.svg": "c835",
	"./icons-24/invoice.svg": "6885",
	"./icons-24/message.svg": "2116",
	"./icons-24/messager.svg": "b346",
	"./icons-24/new-message.svg": "462e",
	"./icons-24/new-note.svg": "b3ae",
	"./icons-24/package.svg": "234a",
	"./icons-24/payments.svg": "0940",
	"./icons-24/product.svg": "9e50",
	"./icons-24/recurring-appointment.svg": "0245",
	"./icons-24/recurring-event.svg": "a943",
	"./icons-24/register-to-event.svg": "9fff",
	"./icons-24/request-payment.svg": "a928",
	"./icons-24/request_signature.svg": "f104",
	"./icons-24/review.svg": "f0d6",
	"./icons-24/send-promotion.svg": "bd58",
	"./icons-24/web-chat.svg": "be4c",
	"./icons-24/whatsapp.svg": "50f1",
	"./icons-28/canceled-appointment.svg": "b75f",
	"./icons-28/expired.svg": "08a1",
	"./icons-28/hand-cash.svg": "575b",
	"./icons-28/last-appointment.svg": "a7cc",
	"./icons-28/noshow.svg": "c16b",
	"./icons-28/package.svg": "03b1",
	"./icons-28/pending-payments.svg": "e4c3",
	"./icons-28/total-payments.svg": "5c31",
	"./icons-28/upcoming-appointment.svg": "26a4",
	"./icons-28/zoom.svg": "cee3",
	"./icons-misc/Add_to_website.svg": "5d99",
	"./icons-misc/App_client_portal.svg": "f202",
	"./icons-misc/Direct_Links.svg": "a5e0",
	"./icons-misc/Document.svg": "d751",
	"./icons-misc/Invite_clients.svg": "fb61",
	"./icons-misc/amex.svg": "7e6b",
	"./icons-misc/amexa.svg": "2491",
	"./icons-misc/campaign.svg": "d1d1",
	"./icons-misc/diners.svg": "d0c8",
	"./icons-misc/discover.svg": "6acd",
	"./icons-misc/discovera.svg": "0d74",
	"./icons-misc/empty_autobilling_method.svg": "3f77",
	"./icons-misc/invoice_draft.svg": "b89e",
	"./icons-misc/jcb.svg": "bdd8",
	"./icons-misc/maestro.svg": "84a7",
	"./icons-misc/mastercard.svg": "6283",
	"./icons-misc/mastercarda.svg": "8d2c",
	"./icons-misc/multi-users.svg": "8454",
	"./icons-misc/new_invoice.svg": "51a0",
	"./icons-misc/play.svg": "ccb7",
	"./icons-misc/record_payment.svg": "3f7e",
	"./icons-misc/unionpay.svg": "3958",
	"./icons-misc/upload.svg": "5604",
	"./icons-misc/user.svg": "c828",
	"./icons-misc/visa.svg": "47db",
	"./icons-misc/visaa.svg": "dc80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19e1";